@if (isSubsidiary) {
    <div class="checkbox float-end">
        <label>
            <input type="checkbox"
                   [(ngModel)]="currentData.useTopLevelCompanySettings"
                   [disabled]="areNoTopLevelSettings || !editMode"
                   (change)="useTopLevelChanged()"
                   data-qa="transmit-use-top-level"> Use Top Level Company Settings
        </label>
    </div>
}

<fieldset [disabled]="currentData.useTopLevelCompanySettings || !isCompany" style="width: 100%;">
    <table class="delivery-details">
        <tr>
            <td>Output Type:</td>
            <td>
                <select class="form-select form-select-sm"
                        [(ngModel)]="currentData.transmittalOutputTypeID"
                        [disabled]="!editMode"
                        data-qa="transmit-output-type">
                    @for (option of transmittalOutputTypes; track option; let i = $index) {
                        <option [ngValue]="option.id" [attr.data-qa]="'transmit-output-type-option-' + i">{{ option.name }}</option>
                    }
                </select>
                @if (currentData.transmittalOutputTypeID) {
                    <button (click)="launchConfigureModal()"
                            type="button"
                            class="ace-btn btn-sm btn-primary"
                            data-qa="transmit-configure">
                        {{ !currentData.useTopLevelCompanySettings && editMode ? 'Configure' : 'View' }}
                    </button>
                }
            </td>
            <td>
                <div class="checkbox">
                    <label>
                        <input type="checkbox"
                               [(ngModel)]="currentData.isMaxPackageSize"
                               [disabled]="!currentData.transmittalOutputTypeID || !editMode"
                               (change)="maybeNullInputs()"
                               data-qa="transmit-max-package-size"> Maximum
                    </label>
                </div>
            </td>
            <td>
                <input class="form-control"
                       type="text"
                       [(ngModel)]="currentData.maxPackageSize"
                       currencyMask
                       [options]="{ allowNegative: false, precision: 0, prefix: ''}"
                       [min]="1"
                       [max]="1000"
                       [disabled]="!currentData.transmittalOutputTypeID || !currentData.isMaxPackageSize || !editMode"
                       data-qa="transmit-max-package-size-input">
                <span style="margin-left: 8px;">MB package size</span>
            </td>
        </tr>
        <tr>
            <td>Transmit Cover:</td>
            <td>
                <select class="form-select form-select-sm"
                        [(ngModel)]="currentData.transmittalFormatID"
                        [disabled]="!currentData.transmittalOutputTypeID || !editMode"
                        data-qa="transmit-cover">
                    @for (option of transmittalFormats; track option; let i = $index) {
                        <option [ngValue]="option.id" [attr.data-qa]="'transmit-cover-option-' + i">{{ option.name }}</option>
                    }
                </select>
                @if (showSiteDescriptorsSelector) {
                    <site-descriptors-edit
                        [isEditMode]="editMode"
                        [companyId]="entity.id"
                        [siteDescriptors]="currentData.siteDescriptors"
                        (siteDescriptorsChanged)="onSiteDescriptorsChanged($event)">
                    </site-descriptors-edit>
                }
            </td>
            <td>
                <div class="checkbox">
                    <label>
                        <input type="checkbox"
                               [(ngModel)]="currentData.isMaxPaymentItems"
                               [disabled]="!currentData.transmittalOutputTypeID || !editMode"
                               (change)="maybeNullInputs()"
                               data-qa="transmit-max-payment-items"> Maximum
                    </label>
                </div>
            </td>
            <td>
                <input class="form-control"
                       type="text"
                       [(ngModel)]="currentData.maxPaymentItemsPerTransmittal"
                       currencyMask
                       [min]="1"
                       [max]="1000"
                       [options]="{ allowNegative: false, precision: 0, prefix: ''}"
                       [disabled]="!currentData.transmittalOutputTypeID || !currentData.isMaxPaymentItems || !editMode"
                       data-qa="transmit-max-payment-items-input">
                <span style="margin-left: 8px;">payment items per transmittal</span>
            </td>
        </tr>
        <tr>
            <td>Package Cover:</td>
            <td>
                <select
                    class="form-select form-select-sm"
                    [(ngModel)]="currentData.transmittalPackageCoverId"
                    [disabled]="!editMode"
                    data-qa="transmit-package-cover">
                    @for (option of transmittalPackageCovers; track option; let i = $index) {
                        <option [ngValue]="option.id" [attr.data-qa]="'transmit-package-cover-option-' + i">{{ option.name }}</option>
                    }
                </select>
            </td>
            <td>
                <div class="checkbox">
                    <label>
                        <input type="checkbox"
                               [(ngModel)]="currentData.isOne"
                               [disabled]="!currentData.transmittalOutputTypeID || !editMode"
                               (change)="maybeNullInputs()"
                               data-qa="transmit-is-one"> One
                    </label>
                </div>
            </td>
            <td>
                <select
                    class="form-select form-select-sm"
                    [(ngModel)]="currentData.deliveryDetailPerPackageLimitTypeID"
                    [disabled]="!currentData.transmittalOutputTypeID || !currentData.isOne || !editMode"
                    data-qa="transmit-per-package-limit-type">
                    @for (option of deliveryDetailPerPackageLimitTypes; track option; let i = $index) {
                        <option [ngValue]="option.id" [attr.data-qa]="'transmit-per-package-limit-type-option-' + i">{{ option.name }}</option>
                    }
                </select>
                <span style="margin-left: 8px;">per package</span>
            </td>
        </tr>
        <tr>
            <td>Group By:</td>
            <td>
                <select
                    class="form-select form-select-sm"
                    [(ngModel)]="currentData.transmittalGroupByID"
                    [disabled]="!currentData.transmittalOutputTypeID || !editMode"
                    data-qa="transmit-group-by">
                    @for (option of transmittalGroupBys; track option; let i = $index) {
                        <option [ngValue]="option.id" [attr.data-qa]="'transmit-group-by-option-' + i">{{ option.name }}</option>
                    }
                </select>
            </td>
            <td colspan="2">
                <div class="checkbox">
                    <label>
                        <input type="checkbox"
                               [(ngModel)]="currentData.consolidateTransmittalAttachment"
                               [disabled]="!editMode"
                               data-qa="transmit-consolidate-attachment">Consolidate Transmittal Attachment
                    </label>
                </div>
            </td>
        </tr>
        <tr>
            <td>Message:</td>
            <td>
                <select
                    class="form-select form-select-sm"
                    [ngModel]="currentData.packageEmailTemplateID"
                    (ngModelChange)="maybeLaunchCustomModal($event)"
                    [disabled]="!editMode"
                    data-qa="transmit-message-template">
                    @for (option of packageEmailTemplates; track option; let i = $index) {
                        <option [ngValue]="option.packageEmailTemplateID" [attr.data-qa]="'transmit-message-template-option-' + i">{{ option.name }}</option>
                    }
                </select>
                @if (!currentData.packageEmailTemplateID) {
                    <button class="ace-btn btn-sm btn-primary"
                            [disabled]="!editMode" (click)="maybeLaunchCustomModal()"
                            data-qa="transmit-message-edit">
                        Edit
                    </button>
                }
                @if (currentData.packageEmailTemplateID) {
                    <button class="ace-btn btn-sm btn-primary"
                            [disabled]="!editMode"
                            (click)="previewTemplate()"
                            data-qa="transmit-message-view">
                        View
                    </button>
                }
            </td>
            <td colspan="2">
                <div class="checkbox">
                    <label>
                        <input
                            type="checkbox"
                            [(ngModel)]="currentData.skipBillImage"
                            [disabled]="!editMode"
                            data-qa="transmit-omit-bill-images">
                        Omit Transmittal Bill Images
                    </label>
                </div>
            </td>
        </tr>
        <tr>
            <td>
                @if (isBillPay) {
                    Check Group By:
                }
            </td>
            <td>
                @if (isBillPay) {
                    <div style="display: inline-block;">
                        <select
                            class="form-select form-select-sm"
                            [(ngModel)]="currentData.checkFeedGroupById"
                            [disabled]="!editMode"
                            data-qa="transmit-check-group-by">
                            @for (option of checkGroupBys; track option; let i = $index) {
                                <option [ngValue]="option.id" [attr.data-qa]="'transmit-check-group-by-option-' + i">{{ option.name }}</option>
                            }
                        </select>
                        <i class="fa fa-info-circle"
                            style="margin-left: 7px;"
                            title="Changing Check Group By shall only apply to Payment Batch Check Feeds generated after the change and not affect previously generated Check Feeds.">
                        </i>
                    </div>
                }
            </td>
            <td>
                @if (isBillPay) {
                    <div class="checkbox">
                        <label>
                            <input type="checkbox"
                                   [(ngModel)]="currentData.isMaxPaymentsPerBatch"
                                   [disabled]="!editMode"
                                   (change)="maybeNullInputs()"
                                   data-qa="transmit-max-payments-per-batch"> Maximum
                        </label>
                    </div>
                }
            </td>
            <td>
                @if (isBillPay) {
                    <div style="display: inline-block;">
                        <input class="form-control"
                               type="text"
                               [(ngModel)]="currentData.maxPaymentsPerPaymentBatch"
                               currencyMask
                               [min]="1"
                               [max]="1000"
                               [options]="{ allowNegative: false, precision: 0, prefix: ''}"
                               [disabled]="!currentData.isMaxPaymentsPerBatch || !editMode"
                               data-qa="transmit-max-payments-per-batch-input">
                        <span style="margin-left: 8px;">payments per Batch</span>
                    </div>
                }
            </td>
        </tr>
    </table>
</fieldset>
